import { Pipe, PipeTransform } from '@angular/core';

/**
 * @description Splits an input string by some delimiter; default is ','.
 * If the input value is not of type string the pipe will return undefined.
 *
 * @example
 * ```html
 * {{ '1,2' | split }} // -> ['1', '2']
 * {{ '1 2' | split:' ' }} // -> ['1', '2']
 * {{ 12 | split }} // -> undefined
 * {{ null | split }} // -> undefined
 * ```
 */
@Pipe({
  standalone: true,
  name: 'split',
})
/*eslint-disable-next-line @angular-eslint/use-pipe-transform-interface*/
export class SplitValuePipe implements PipeTransform {
  transform(value: unknown, separator = ','): string[] | undefined {
    return typeof value === 'string' ? value.split(separator) : undefined;
  }
}
